function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  className: "cc1",
  d: "M15.2,12.8H1.7c-0.7,0-1.3-0.6-1.3-1.3V6.8v-1v-1v-1V2  c0-0.7,0.6-1.3,1.3-1.3h13.4c0.7,0,1.3,0.6,1.3,1.3v1.7v1v6.7C16.5,12.2,15.9,12.8,15.2,12.8z M15.4,1.8h-14v2h14V1.8z M15.4,4.8  h-14v1h5v1h-5v5h14V4.8z M9.4,7.8c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S8.9,7.8,9.4,7.8z M12.4,7.8c0.6,0,1,0.4,1,1s-0.4,1-1,1  s-1-0.4-1-1S11.9,7.8,12.4,7.8z"
});

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.9 13.5",
    enableBackground: "new 0 0 16.9 13.5",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit_card.a08a0244.svg";
export { ForwardRef as ReactComponent };